/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiRole } from './ApiRole';
import {
    ApiRoleFromJSON,
    ApiRoleFromJSONTyped,
    ApiRoleToJSON,
    ApiRoleToJSONTyped,
} from './ApiRole';
import type { ApiOrganisation } from './ApiOrganisation';
import {
    ApiOrganisationFromJSON,
    ApiOrganisationFromJSONTyped,
    ApiOrganisationToJSON,
    ApiOrganisationToJSONTyped,
} from './ApiOrganisation';

/**
 * A User
 * @export
 * @interface ApiUser
 */
export interface ApiUser {
    /**
     * 
     * @type {number}
     * @memberof ApiUser
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiUser
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUser
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiUser
     */
    inactive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiUser
     */
    locked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiUser
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUser
     */
    intercomUserHash?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUser
     */
    intercomUserEmail?: string;
    /**
     * 
     * @type {Array<ApiRole>}
     * @memberof ApiUser
     */
    roles: Array<ApiRole>;
    /**
     * 
     * @type {ApiOrganisation}
     * @memberof ApiUser
     */
    organisation?: ApiOrganisation;
}

/**
 * Check if a given object implements the ApiUser interface.
 */
export function instanceOfApiUser(value: object): value is ApiUser {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    return true;
}

export function ApiUserFromJSON(json: any): ApiUser {
    return ApiUserFromJSONTyped(json, false);
}

export function ApiUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'],
        'inactive': json['inactive'] == null ? undefined : json['inactive'],
        'locked': json['locked'] == null ? undefined : json['locked'],
        'password': json['password'] == null ? undefined : json['password'],
        'intercomUserHash': json['intercomUserHash'] == null ? undefined : json['intercomUserHash'],
        'intercomUserEmail': json['intercomUserEmail'] == null ? undefined : json['intercomUserEmail'],
        'roles': ((json['roles'] as Array<any>).map(ApiRoleFromJSON)),
        'organisation': json['organisation'] == null ? undefined : ApiOrganisationFromJSON(json['organisation']),
    };
}

export function ApiUserToJSON(json: any): ApiUser {
    return ApiUserToJSONTyped(json, false);
}

export function ApiUserToJSONTyped(value?: ApiUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'name': value['name'],
        'inactive': value['inactive'],
        'locked': value['locked'],
        'password': value['password'],
        'intercomUserHash': value['intercomUserHash'],
        'intercomUserEmail': value['intercomUserEmail'],
        'roles': ((value['roles'] as Array<any>).map(ApiRoleToJSON)),
        'organisation': ApiOrganisationToJSON(value['organisation']),
    };
}

